import PageHeader from '../../components/headers/PageHeader';
import UploadGoogleReviewScreen from '../../../../pages/UploadGoogleReviewScreen';
import { IonContent } from '@ionic/react';
import { useTranslation } from 'react-i18next';

const UploadGoogleReview = (): JSX.Element => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:UploadGoogleReview' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent className="min-h-[80dvh] space-y-sm">
        <UploadGoogleReviewScreen hasHeader={false} />
      </IonContent>
    </>
  );
};

export default UploadGoogleReview;
